import { Observable, from, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from './api';
import { ENDPOINTS } from '@/settings/api-settings';

export function getUFs(): Observable<any[]> {
  const UFs = [
    [
      { value: 'AC', label: 'AC' },
      { value: 'AL', label: 'AL' },
      { value: 'AM', label: 'AM' },
      { value: 'AP', label: 'AP' },
      { value: 'BA', label: 'BA' },
      { value: 'CE', label: 'CE' },
      { value: 'DF', label: 'DF' },
      { value: 'ES', label: 'ES' },
      { value: 'GO', label: 'GO' },
      { value: 'MA', label: 'MA' },
      { value: 'MG', label: 'MG' },
      { value: 'MS', label: 'MS' },
      { value: 'MT', label: 'MT' },
      { value: 'PA', label: 'PA' },
      { value: 'PB', label: 'PB' },
      { value: 'PE', label: 'PE' },
      { value: 'PI', label: 'PI' },
      { value: 'PR', label: 'PR' },
      { value: 'RJ', label: 'RJ' },
      { value: 'RN', label: 'RN' },
      { value: 'RO', label: 'RO' },
      { value: 'RR', label: 'RR' },
      { value: 'RS', label: 'RS' },
      { value: 'SC', label: 'SC' },
      { value: 'SE', label: 'SE' },
      { value: 'SP', label: 'SP' },
      { value: 'TO', label: 'TO' },
    ],
  ];
  return from(UFs).pipe(map((data: any) => data));
}

let diffDateServerMilli = 0;
export function getServerDateTime(): Observable<Date> {
  return from(apiClient.get(ENDPOINTS.UTILS_DATETIME)).pipe(
    map((r: any) => {
      let timezone = Date.parse(r.data);
      let date: Date = null;
      if (!timezone) {
        var arr = r.data.split(/[\-\+ :T]/);
        date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
      } else {
        date = new Date(timezone);
      }
      let timeServer = date.getTime();
      let timeLocal = new Date().getTime();
      diffDateServerMilli = Number(timeServer) - Number(timeLocal);
      return date;
    }),
  );
}

export function getDiffDateServerMilli() {
  return diffDateServerMilli;
}

export function getServerISODate(): Observable<string> {
  return from(
    getServerDateTime().pipe(
      map((r) => {
        return Object.assign(new Date(), r)
          .toISOString()
          .substring(0, 10);
      }),
    ),
  );
}

export function getServerISODateTime(): Observable<string> {
  return from(
    getServerDateTime().pipe(
      map((r) => {
        return Object.assign(new Date(), r).toISOString();
      }),
    ),
  );
}

export class ErrorLogDTO {
  idLogin: number;
  nomeUsuario: string;
  httpStatus: number;
  message: string;
  url: string;
  configs: string;
  headers: string;
  errors: string;
  segundosUltRequest: number;
  href: string;
}

export function postErrorLog(log: ErrorLogDTO): Observable<Boolean> {
  if (log.url == ENDPOINTS.UTILS_ERROR_LOG) {
    return of(false);
  }
  return from(apiClient.post(ENDPOINTS.UTILS_ERROR_LOG, log)).pipe(
    map((r: any) => {
      return r;
    }),
  );
}

export function isProduction(): Observable<boolean> {
  return from(apiClient.get(ENDPOINTS.UTILS_IS_PRODUCTION)).pipe(
    map((r: any) => {
      return r.data;
    }),
  );
}
